import { Component, Input } from '@angular/core';
import { ReminderSnapshotResponse } from '../../../../../services/reminder-analytics/reminder-analytics.model';

@Component({
    selector: 'app-reminder-kpi-cards',
    templateUrl: './reminder-kpi-cards.component.html',
    styleUrls: ['./reminder-kpi-cards.component.scss'],
})
export class ReminderKpiCardsComponent {
    @Input() snapshot: ReminderSnapshotResponse;
    @Input() comparePrevious = false;

    get totalDelta(): number | null {
        if (!this.comparePrevious || this.snapshot?.totalReminders?.previous === undefined) return null;
        return this.snapshot.totalReminders.current - this.snapshot.totalReminders.previous;
    }

    get deliveryRateDelta(): number | null {
        if (!this.comparePrevious || this.snapshot?.deliveryRate?.previous === undefined) return null;
        return +(this.snapshot.deliveryRate.current - this.snapshot.deliveryRate.previous).toFixed(1);
    }

    get failureRateDelta(): number | null {
        if (!this.comparePrevious || this.snapshot?.failureRate?.previous === undefined) return null;
        return +(this.snapshot.failureRate.current - this.snapshot.failureRate.previous).toFixed(1);
    }

    get usersReachedDelta(): number | null {
        if (!this.comparePrevious || this.snapshot?.uniqueUsersReached?.previous === undefined) return null;
        return this.snapshot.uniqueUsersReached.current - this.snapshot.uniqueUsersReached.previous;
    }

    get avgDeliveryTimeDelta(): number | null {
        if (!this.comparePrevious || this.snapshot?.avgDeliveryTime?.previous === undefined) return null;
        return +(this.snapshot.avgDeliveryTime.current - this.snapshot.avgDeliveryTime.previous).toFixed(1);
    }
}
